import { Accordion } from "react-bootstrap"
import AdminListTable from "../AdminListTable"
import { useState } from "react";
import ClearFilterButton from "../../../../Components/ClearFilterButton";
import ToTheUserTable from "./ToTheUserTable";
import { useNavigate } from "react-router-dom";
import TokenService from '../../../../Services/Token.service';
function ToTheUser({useType, eventKey}) {

    const [filterCount, setFilterCount] = useState(0);
    const [isClearFilter, setIsClearFilter] = useState(false);
    const handleFilterCountChange = (count) => {
        setFilterCount(count); // Update filter count
    };
    const handleClearFilters = () => {
        setIsClearFilter(true);
        setTimeout(() => setIsClearFilter(false), 0);
    };
    const navigate = useNavigate();

    return (
        <>
            <Accordion.Item className="mb-3" eventKey={eventKey}>
                <Accordion.Header>
                    {/* <b>To the Requestors</b> */}

                    <div className="d-flex justify-content-between">
                        <div className="d-flex justify-content-between align-items-center">
                            <div style={{marginRight:'15px'}}>
                            <h3>{useType!="admin" ? (<>To the {useType.slice(0,1).toUpperCase() }{useType.slice(1)}</>) : (<>To the Super Admins and Admins</>)}</h3>
                            </div>  
                            {filterCount > 0 && (<ClearFilterButton handleClearFilters={handleClearFilters} />)}
                            {filterCount > 0 && (<span className="m-2">Filters applied: {filterCount}</span>)}
                        </div>
                        <div className="ps-3">
                            <button variant="secondary" onClick={()=> {TokenService.updatePrevLink('/admin/email-sms-management'); navigate(`add-template/${useType}`)}} className="el-main-button me-0"> <span>New Template</span> </button>
                        </div>
                    </div>

                </Accordion.Header>
                <Accordion.Body>
                    <>  
                        <ToTheUserTable type={useType} isClearFilter={isClearFilter} onFilterCountChange={handleFilterCountChange} />                          
                    </>
                </Accordion.Body>
            </Accordion.Item>
        </>
    )
}

export default ToTheUser